import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_right_outlined",
  "use": "icon-icon_right_outlined-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_right_outlined\">\r\n<path d=\"M10.8521 8.00004L5.43097 2.57889C5.30079 2.44872 5.30079 2.23766 5.43097 2.10749L5.90237 1.63608C6.03254 1.50591 6.2436 1.50591 6.37377 1.63608L12.2663 7.52864C12.5267 7.78899 12.5267 8.2111 12.2663 8.47145L6.37377 14.364C6.2436 14.4942 6.03254 14.4942 5.90237 14.364L5.43097 13.8926C5.30079 13.7624 5.30079 13.5514 5.43097 13.4212L10.8521 8.00004Z\" fill=\"#8F959E\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol